<template>
  <div class="voice-room-detail" ref="main">
    <el-card class="detail-box" v-if="voiceRoomDetail">
      <div slot="header" class="clearfix">
        <span>{{$t('upgrade_page_views_administrator_management_voice_room_detail_1983')}}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="editVoiceRoom()"
          >{{$t('upgrade_page_views_administrator_management_voice_room_detail_1984')}}</el-button
        >
      </div>
      <div v-if="voiceRoomDetail && voiceRoomDetail.roomUid">
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1985')}}</span>
          <div class="value">
            <el-image
              fit="cover"
              style="width: 100px; height: 100px;margin-bottom:10px "
              :preview-src-list="[voiceRoomDetail.coverImgUrl]"
              :src="voiceRoomDetail.coverImgUrl"
            >
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1986')}}</span>
          <div class="value">
            <el-image
              fit="cover"
              style="width: 100px; height: 100px;margin-bottom:10px "
              :src="voiceRoomDetail.backImgUrl"
              :preview-src-list="[voiceRoomDetail.coverImgUrl]"
            >
            </el-image>
          </div>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1987')}}</span>
          <span class="value">
            {{ voiceRoomDetail.roomUid }}
          </span>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1988')}}</span>
          <span class="value">{{ voiceRoomDetail.name }}</span>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1989')}}</span>
          <span class="value">{{ voiceRoomDetail.createBy }}</span>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1990')}}</span>
          <span class="value">{{
            voiceRoomDetail.recommend == 1 ? $t('utils_util_1387') : $t('upgrade_page_views_administrator_management_voice_room_detail_1991')
          }}</span>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1992')}}</span>
          <p class="value">
            {{ voiceRoomDetail.desc }}
          </p>
        </div>
        <div class="item">
          <span class="label">{{$t('upgrade_page_views_administrator_management_voice_room_detail_1993')}}</span>
          <div>
            <el-switch
              v-model="voiceRoomDetail.open"
              :active-value="1"
              :inactive-value="0"
              :active-text="$t('utils_util_1387')"
              :inactive-text="$t('upgrade_page_views_administrator_management_voice_room_detail_1991')"
              @change="handleOpen"
            >
            </el-switch>
          </div>
        </div>
        <!-- <div class="item">
          <span class="label">管理員</span>
          <div class="value">
            <div
              v-for="item of voiceRoomDetail.adminUsers"
              :key="item.adminUsers"
            >
              <span>{{ item.nickname }}</span
              ><span>({{ item.uuid }})</span>
            </div>
          </div>
        </div> -->
      </div>
      <div v-else>{{$t('upgrade_page_views_administrator_management_voice_room_detail_1994')}}</div>
    </el-card>
    <edit-voice-room-vue
      :voiceRoomDetail="voiceRoomDetail"
      ref="editForm"
      @update-success="editVoiceRoomSuccess"
    ></edit-voice-room-vue>
  </div>
</template>
<script>
import i18n from '../../../locales/index'

import EditVoiceRoomVue from './voice-room-form.vue';
// import { mapGetters } from 'vuex';
export default {
  name: 'UserList',
  components: {
    EditVoiceRoomVue
  },
  props: {
    isWhiteUser: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    voiceRoomDetail: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      addLoading: false
    };
  },
  computed: {
    roomUid() {
      return this.voiceRoomDetail.roomUid || '';
    }
  },
  methods: {
    editVoiceRoom() {
      if (!this.roomUid) {
        return;
      }
      this.$refs.editForm.open();
    },
    editVoiceRoomSuccess() {
      this.$emit('edit-voice-room-success');
    },
    handleOpen($event) {
      try {
        this.$http.post('/voiceRoom/admin/updateOpen', {
          open: $event,
          roomUid: this.roomUid
        });
      } catch (error) {
        this.voiceRoomDetail.open = !this.voiceRoomDetail.open;
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.voice-room-detail {
  height: 100%;
}
.detail-box {
  min-width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .clearfix {
    flex: none;
  }
  /deep/ .el-card__body {
    height: 1px;
    flex: auto;
    overflow: auto;
  }
  .item {
    display: flex;
    margin-bottom: 20px;
    .label {
      width: 100px;
      color: #99a9bf;
    }
    .value {
      max-width: 160px;
      line-height: 1.5;
    }
  }
}
</style>
